import { createStore } from 'vuex';
import stores from './modules/stores';
import delivery from './modules/delivery';
import countries from './modules/countries';
import users from './modules/users';
import packages from "./modules/packages";
import payment from "./modules/payment";
import purchaseRequest from './modules/purchaseRequest';
import mail from './modules/mail';
import review from './modules/review';
import boxberry from './modules/boxberry';
import cargo from './modules/cargo';

const store = createStore({
    modules: {
        stores: stores,
        delivery: delivery,
        countries: countries,
        users: users,
        packages: packages,
        payment: payment,
        purchaseRequest: purchaseRequest,
        mail: mail,
        review: review,
        boxberry: boxberry,
        cargo: cargo
    }
});

export default store;
